import React from "react";
import { rowColumn, tableOptions } from "../../../components/table/Table";

export const departmentApplicationListTable: rowColumn[] = [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "First Name",
    column: "applicationBase.child.firstName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Child.FirstName",
  },
  {
    label: "Last Name",
    column: "applicationBase.child.lastName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Child.LastName",
  },
  {
    label: "Kindergarten",
    column: "applicationBase.kindergarten.fundedKinderName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Kindergarten.FundedKinderName",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.applicationBase.kindergarten?.fundedKinderName === "Other"
            ? rowData.applicationBase.kindergarten?.kindergartenNameOther
            : rowData.applicationBase.kindergarten?.fundedKinderName}
        </p>
      );
    },
    isFilter: true,
    filterType: "search",
    filterKeyColumns: ["applicationBase.Kindergarten.fundedKinderName", "applicationBase.Kindergarten.kindergartenNameOther"],
  },
  {
    label: "Date Submitted",
    column: "applicationBase.dateSubmitted",
    type: "date",
    allowSort: true,
    sortOn: "ApplicationBase.DateSubmitted",
  },
  {
    label: "Actions",
    body: (rowData) => <a href={`applications/${rowData.id}`}>View Details</a>,
  },
];

export const departmentTableOptions: tableOptions = {
  sortField: undefined,
  sortOrder: undefined,
  filters: {
    "applicationBase.discriminator": {
      searchFilter: "ApplicationBaseCurrent",
    },
    "applicationBase.assignStatus.description": {
      exclude: true,
      searchFilter: "Presubmission",
    },
  },
};
